(() => {
  const configElement = document.getElementById('cjnz-personalised-delay-config');
  if (!configElement) return;

  if (document.querySelector('[data-section-type="cart-template"]')) return;

  const config = JSON.parse(configElement.textContent);
  const personalisedHandles = new Set(config.productHandles || []);

  const hasPersonalisationProperty = (item) => Object.entries(item.properties || {}).some(([name, value]) => {
    const normalizedName = String(name).toLowerCase();
    return Boolean(String(value || '').trim())
      && (normalizedName.includes('embroider') || normalizedName.includes('personalis'));
  });

  const isPersonalisedCart = (cart) => (cart?.items || []).some((item) => (
    personalisedHandles.has(item.handle) || hasPersonalisationProperty(item)
  ));

  const candidateContainers = () => {
    const containers = new Set(document.querySelectorAll(
      '.checkout-buttons, .checkout-col, .ajaxcart__footer, .cart-drawer__footer, .drawer__footer'
    ));

    document.querySelectorAll('[name="checkout"], a[href*="/checkout"]').forEach((control) => {
      containers.add(control.closest('.checkout-buttons, .checkout-col, form, div') || control.parentElement);
    });

    const candidates = [...containers].filter(Boolean);
    return candidates.filter((container) => !candidates.some((other) => (
      other !== container && container.contains(other)
    )));
  };

  const setNotice = (container, visible) => {
    let notice = container.querySelector(':scope > [data-cjnz-personalised-delay]');
    if (!visible) {
      if (notice) notice.remove();
      return;
    }
    if (notice) return;

    notice = document.createElement('div');
    notice.className = 'cjnz-personalised-delay-notice';
    notice.dataset.cjnzPersonalisedDelay = '';
    notice.setAttribute('role', 'status');
    notice.innerHTML = '<strong>Personalised item dispatch</strong><br>';
    notice.append(document.createTextNode(config.message));
    container.prepend(notice);
  };

  const updateNotices = async () => {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .catch(() => null);
    if (!cart) return;

    const visible = isPersonalisedCart(cart);
    candidateContainers().forEach((container) => setNotice(container, visible));
  };

  let updateTimer;
  const scheduleUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateNotices, 250);
  };

  updateNotices();
  document.addEventListener('click', scheduleUpdate, true);
  document.addEventListener('submit', scheduleUpdate, true);

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { childList: true, subtree: true });
})();
